export enum ValidationRuleEnum {
    ContractRequestDuplicate = 1,
    MoneyMovement = 2,
    MinimumWageRate = 5
}
